module.exports = __webpack_public_path__ + "img/icon-diners.dab7fe9a.svg";